<div
  class="flex h-full flex-col rounded-lg border border-greyscale-200 bg-primary-50 p-4 transition-shadow"
>
  <div class="mb-3 flex items-start gap-3">
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100"
    >
      <lucide-icon name="video" class="text-primary-600" [size]="20" />
    </div>
    <h4 class="text-heading-5 font-semibold text-greyscale-900">
      {{ webinar().titleKey | transloco }}
    </h4>
  </div>

  <p class="mb-4 flex-1 text-sm text-greyscale-600">
    {{ webinar().descriptionKey | transloco }}
  </p>

  <div class="mb-4 flex items-center gap-2 text-sm text-greyscale-700">
    <lucide-icon name="clock" class="text-greyscale-400" [size]="16" />
    <span
      >{{ "help.onboarding.webinars.duration" | transloco }} :
      {{ webinar().duration }}</span
    >
  </div>

  <div class="flex items-center gap-3">
    <div
      class="flex items-center gap-1.5 text-paragraph-s-reg text-greyscale-700"
    >
      <lucide-icon name="user-plus" [size]="16" class="text-greyscale-500" />
      {{ "help.onboarding.webinars.register" | transloco }} :
    </div>
    <div class="flex flex-1 gap-4">
      @for (entry of registrationLanguages; track entry.lang) {
        <a
          [href]="entry.url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex-1 rounded-md border border-primary-200 px-3 py-1 text-center text-paragraph-s-reg font-medium text-primary-400 transition-colors hover:bg-primary-100"
        >
          {{ entry.lang | uppercase }}
        </a>
      }
    </div>
  </div>
</div>
